/** Reserve the content area immediately; show feedback only for slower loads. */
export function ContentSkeleton({ message }: { message: string }) {
  return (
    <div
      role="status"
      aria-label={message}
      className="loading-placeholder space-y-5"
    >
      <p className="text-sm text-muted">{message}</p>
      <div aria-hidden="true" className="space-y-5">
        {Array.from({ length: 3 }, (_, i) => (
          <div key={i} className="animate-pulse space-y-3">
            <div className="h-3 w-40 rounded bg-line" />
            <div className="h-24 rounded bg-surface-2" />
          </div>
        ))}
      </div>
    </div>
  );
}
